export default "__VITE_ASSET__C84FFTGx__"